var styles = {"root":"FAQs-module_root__1ktHK","accordionWrapper":"FAQs-module_accordionWrapper__AegnG","link":"FAQs-module_link__EREKN"};

export { styles as default };
//# sourceMappingURL=FAQs.module.css.js.map
